import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const AchievementsView = lazy(async () => {
  const m = await import("@/features/gamification/components/achievements-view");
  return { default: m.AchievementsView };
});

export const achievementsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/achievements",
  component: () => (
    <Suspense fallback={null}>
      <AchievementsView />
    </Suspense>
  ),
});
